import React from "react";

import UndoImageRemoval from "./UndoImageRemoval";
import RemoveIconButton from "./RemoveIconButton";

interface RemoveOrUndoProps {
  enableRemoveImage: boolean;
  removeImage(): void;
  enableUndo: boolean;
  undoRemoveImage(): void;
}

export default function RemoveOrUndo({
  enableUndo,
  enableRemoveImage,
  removeImage,
  undoRemoveImage,
}: RemoveOrUndoProps) {
  if (enableUndo) return <UndoImageRemoval onUndo={undoRemoveImage} />;

  return <RemoveIconButton disabled={!enableRemoveImage} onClick={removeImage} />;
}
